// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "app/chunks/" + chunkId + "." + {"node_modules_resize-observer-polyfill_dist_ResizeObserver_es_js":"04c49a6d","node_modules_event-target-shim_dist_event-target-shim_js":"722e680e","node_modules_webex_calling_dist_module_CallingClient_registration_webWorker_js":"a44f98a0"}[chunkId] + ".js";
};